import { useState, useContext } from "react"
import { GlobalContext } from "@Context/context/GlobalContext"
import { executeShipingGroupAction } from "@Services/ShippingGroupService"
import Logger from "@Classes/Logger"
import { TransactionCodeEnum } from "@Enums/TransactionCodeEnum"
import { NOTIFY_PACKING } from "@Helpers/constHelper"
import { ProcessShippingGroupActionType } from "@Types/OrderType"
import { EShippinggroupAction } from "@Enums/shippinggroupEmun"
import useUserPermissions from "@Hooks/UseUserPermissions"
import { ResourcePermissionsEnum } from "@Enums/ResourcePermissionsEnum"

const usePackageOrder = ({
  setFinishedShippingGroupAction,
  shippingGroupId,
  isElocker
}: ProcessShippingGroupActionType) => {
  const [loadingPackage, setLoadingPackage] = useState(false)

  const { notification, errorHander } = useContext(GlobalContext)

    const { permission } = useUserPermissions({
      resources: [
        ResourcePermissionsEnum.qrEntry,
        ResourcePermissionsEnum.qrExit,
        ResourcePermissionsEnum.qrCancel,
        ResourcePermissionsEnum.packingElocker,
      ],
    })

  const handleClickPackageOrder = async () => {
    try {
      setLoadingPackage(true)
      const {
        data: { code },
      } = await executeShipingGroupAction({
        shippingGroupId,
        action: EShippinggroupAction.packed,
      })

      setLoadingPackage(false)

      //picking success TODO:: case error
      if (code === TransactionCodeEnum.ok) {
        setFinishedShippingGroupAction(true)

        notification?.dispatch({
          type: "ADD_NOTIFICATION",
          payload: {
            message: "Productos empacados correctamente",
            title: NOTIFY_PACKING,
            type: "success",
          },
        })
      }
    } catch (error: any) {
      setLoadingPackage(false)
      Logger.error(error)
      errorHander?.dispatch({ hasError: true, code: error.response?.status })
    }
  }

  return {
    loadingPackage,
    handleClickPackageOrder,
    denyPackingAction: isElocker && !permission[ResourcePermissionsEnum.packingElocker],
    canViewQrCancel: permission[ResourcePermissionsEnum.qrCancel],
    canViewQrEntry: permission[ResourcePermissionsEnum.qrEntry],
    canViewQrExit: permission[ResourcePermissionsEnum.qrExit],
  }

}

export default usePackageOrder
